import api from "./api";

export const getEMSProfile = () =>
  api.get("/ems/profiles/");

export const getEMSRequests = (params = {}) =>
  api.get("/ems/requests/", { params });

// Dispatcher-only: POST /ems/requests/{id}/assign/ with {assigned_unit: unitId}
// Transitions request PENDING → DISPATCHED and unit → DISPATCHED atomically.
export const assignAmbulance = (requestId, unitId) =>
  api.post(`/ems/requests/${requestId}/assign/`, { assigned_unit: unitId });

// Driver-only: advance state machine DISPATCHED → IN_TRANSIT → COMPLETED
export const updateEMSRequestStatus = (requestId, newStatus) =>
  api.post(`/ems/requests/${requestId}/update_status/`, { status: newStatus });

// Patient or dispatcher: cancel a PENDING or DISPATCHED request
export const cancelEMSRequest = (requestId) =>
  api.post(`/ems/requests/${requestId}/cancel/`);

// Generic PATCH for future use (notes, etc.) — EMSRequestViewSet must add UpdateModelMixin first
export const updateEMSRequest = (id, data) =>
  api.patch(`/ems/requests/${id}/`, data);

export const getAmbulanceUnits = (params = {}) =>
  api.get("/ems/units/", { params });

export const createAmbulanceUnit = (data) =>
  api.post("/ems/units/", data);

export const updateAmbulanceUnit = (id, data) =>
  api.patch(`/ems/units/${id}/`, data);

export const getTransportLogs = (params = {}) =>
  api.get("/ems/transport-logs/", { params });

export const createTransportLog = (data) =>
  api.post("/ems/transport-logs/", data);
